import { render, staticRenderFns } from "./UserQuestCard.vue?vue&type=template&id=5cc9f918&scoped=true&"
import script from "./UserQuestCard.vue?vue&type=script&lang=js&"
export * from "./UserQuestCard.vue?vue&type=script&lang=js&"
import style0 from "./UserQuestCard.vue?vue&type=style&index=0&id=5cc9f918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc9f918",
  null
  
)

export default component.exports